export default function isHexColorCode(color) {
  return /^#[0-9A-F]{6}[0-9a-f]{0,2}$/i.test(color);
}
;
//# sourceMappingURL=isHexColorCode.js.map